import ClearIcon from '@material-ui/icons/Clear';

import TableSearchFilter from './TableSearchFilter';
import TableDateFilter from './TableDateFilter';
import TableDateRangeFilter from './TableDateRangeFilter';
import TableSelectFilter from './TableSelectFilter';
import TableMultiSelectFilter from './TableMultiSelectFilter';

const TableWrapper = (props) => (<div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>{props.children}</div>);
const TableHeaderWrapper = (props) => (<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '50px', whiteSpace: 'nowrap' }}>{props.children}</div>);
const TableFilterWrapper = (props) => (<div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginLeft: '-5px' }}>{props.children}</div>);
const TableDropdownFilterWrapper = (props) => (<div style={{ margin: '0px 5px' }}>{props.children}</div>);

const TableSearchFilterWrapper = (props) => {
  return (
    <TableDropdownFilterWrapper>
      <TableSearchFilter {...props} />
    </TableDropdownFilterWrapper>
  );
};

const TableDateFilterWrapper = (props) => {
  return (
    <TableDropdownFilterWrapper>
      <TableDateFilter {...props} />
    </TableDropdownFilterWrapper>
  );
};

const TableDateRangeFilterWrapper = (props) => {
  return (
    <TableDropdownFilterWrapper>
      <TableDateRangeFilter {...props} />
    </TableDropdownFilterWrapper>
  );
};

const TableSelectFilterWrapper = (props) => {
  return (
    <TableDropdownFilterWrapper>
      <TableSelectFilter {...props} />
    </TableDropdownFilterWrapper>
  );
};

const TableMultiSelectFilterWrapper = (props) => {
  return (
    <TableDropdownFilterWrapper>
      <TableMultiSelectFilter {...props} />
    </TableDropdownFilterWrapper>
  );
};

const ClearFilter = (props) => {
  const { onClick } = props;

  return (
    <div
      style={{ display: 'flex', color: '#f50057', cursor: 'pointer' }}
      onClick={onClick}
    >
      <ClearIcon />
      Clear the Filters
    </div>
  );
};

export { TableWrapper };
export { TableHeaderWrapper };
export { TableFilterWrapper };
export { TableMultiSelectFilterWrapper };
export { TableDropdownFilterWrapper };
export { TableSearchFilterWrapper };
export { TableDateFilterWrapper };
export { TableDateRangeFilterWrapper };
export { TableSelectFilterWrapper };
export { ClearFilter };
